module.exports = __webpack_public_path__ + "static/img/chanpingchongzhi.01b99940.png";